module.exports = __webpack_public_path__ + "static/yelp-icon-d3b4822b24730367b3a4bd0abb6fab0c.svg";